module.exports = __webpack_public_path__ + "static/media/tissuePhloemFiber.e5f5ad38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tissuePhloemFiber.jpg
// module id = 106
// module chunks = 0